<template>
  <div class="statusPage">
    <div class="pageTop">
      <h1>设备指标趋势</h1>
<!--      <h2>景区选择</h2>-->
<!--      <SelectMore @handleSelect="handleSelect" selectType="store"></SelectMore>-->
      <h2>设备选择</h2>
      <SelectMore @handleSelect="handleSelectDevice" selectType="device"></SelectMore>
      <el-select class="mineSelect" v-model="category" placeholder="请选择" multiple >
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <h2>日期选择</h2>
      <el-date-picker
          v-model="dateValue"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
      >
      </el-date-picker>
      <h2>指标筛选</h2>
      <el-select class="mineSelect" v-model="quota" placeholder="请选择" >
        <el-option
            v-for="item in quotaOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="handleQuery">查询</el-button>
    </div>
    <div class="pageTable">
      <EchartsEight ref="trend" :params="params"></EchartsEight>
    </div>

  </div>
</template>

<script>
import SelectMore from "./SelectMore";
import EchartsEight from "./EchartsEight";


export default {
  name: "DeviceTrend",
  data(){
    const start = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-01';
    const end = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();

    return {
      store: '',
      category: ['one','two'],
      options: [
        { value: 'one', label: '771/772' },
        { value: 'two', label: '775' },
      ],
      device: '',
      dateValue: [start, end], //
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      quota: 'sale',
      quotaOptions: [
        { value: 'sale', label: '设备销售额' },
        { value: 'refund', label: '退款率' },
      ]
    }
  },
  methods:{
    handleSelect(val){ // 接收来自组件的数据
      console.log('最新景区', val)
      this.store = val;
    },
    handleSelectDevice(val){ // 设备
      console.log('最新设备', val)
      this.device = val;
    },
    handleQuery(){
      // 查询
      this.$refs.trend.getData(); // 调用子组件的方法
    },

    dateChange(val){
      const [ start, end ] = val;
      console.log(start, end)
      console.log(this.dateValue)
    },
  },
  computed: {
    params(){ // 父组件调用table子组件中的方法
      return {
        device: this.device,
        category: this.category,
        dateValue: this.dateValue,
        quota: this.quota
      }
    }
  },
  components: {
    SelectMore,
    EchartsEight
  }
}
</script>

<style scoped>

/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58D9F9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7CFFB2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}


.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.pageTop h1{
  margin-right: 30px;
  font-size: 22px;
  font-weight: bold;
}

.pageTop h2{
  margin: 0 10px;
}

.pageTop .mineSelect {
  margin: 0 10px;
}

.statusPage,
.deviceBox{
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  border: 1px solid #5c01b8;
  border-radius: 30px;

}

.statusPage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
  margin-top: 30px;
}

.pageTable {
  margin-top: 40px;
}
.el-button {
  margin-left: 10px;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;

}
</style>